import Component from '@bythepixel/component-loader';
import {
  disableBodyScroll,
  enableBodyScroll,
  getCookie,
  lazyLoadIframeInModal,
} from '@Utility';
import { Events } from './events';

function populateButtonLinkAndText(button, stockId) {
  const textEl = button.querySelector('.btn__text');
  // eslint-disable-next-line no-param-reassign
  button.href = `/inventory/details/${stockId}/`;
  textEl.innerText = `View Inventory Item Stock #${stockId}`;
}

export default class YoutubeLivestream extends Component {
  static selector = '[data-comp-youtube-livestream]';

  isMockLivestream;

  constructor(container) {
    super(container);

    this.isMockLivestream = container.dataset.isMockLivestream === 'true';
    this.cssClasses = {
      livestreamActive: 'youtube-livestream--active',
      livestreamFullscreen: 'youtube-livestream--fullscreen',
      livestreamLandscape: 'youtube-livestream--landscape',
      videoWrapper: 'video-wrapper',
    };

    this.selectors = {
      button: '[data-youtube-livestream-button]',
      channel: '[data-youtube-livestream-channel]',
      close: '[data-youtube-livestream-close]',
      cta: '[data-youtube-livestream-cta]',
      details: '[data-youtube-livestream-details]',
      iframe: '[data-youtube-livestream-iframe]',
      minimize: '[data-youtube-livestream-minimize]',
      overlay: '[data-youtube-livestream-overlay]',
      title: '[data-youtube-livestream-title]',
      videoWrapper: '[data-youtube-livestream-video-wrapper]',
    };

    this.cookieName = 'youtubeLivestreamVideoId';
    this.buttonEl = this.$container.querySelector(this.selectors.button);
    this.channelEl = this.$container.querySelector(this.selectors.channel);
    this.closeEl = this.$container.querySelector(this.selectors.close);
    this.ctaEl = this.$container.querySelector(this.selectors.cta);
    this.detailsEl = this.$container.querySelector(this.selectors.details);
    this.iframeEl = this.$container.querySelector(this.selectors.iframe);
    this.minimizeEl = this.$container.querySelector(this.selectors.minimize);
    this.overlayEl = this.$container.querySelector(this.selectors.overlay);
    this.titleEl = this.$container.querySelector(this.selectors.title);
    this.videoWrapperEl = this.$container.querySelector(
      this.selectors.videoWrapper,
    );
    this.breakpoint = 1355;
    this.initialLoad = true;

    (async () => {
      // This if condition checks the livestream on page load
      // If it hasn't detected a livestream, it uses setInterval to check every 30 seconds
      if ((await this.checkIfLivestreaming()) !== true) {
        const checkIfLivestreaming = setInterval(
          async () => {
            if ((await this.checkIfLivestreaming()) === true) {
              // If it's livestreaming, clear the interval
              clearInterval(checkIfLivestreaming);
            }
          },
          30000,
          true,
        ); // Every 30 seconds
      }
    })();
  }

  async checkIfLivestreaming() {
    return fetch('/api/youtube-videos/livestream/', {
      method: 'get',
    })
      .then((response) => response.json())
      .then((json) => {
        if (json.isLivestreaming) {
          this.stockIds = json.stockIds;
          this.initializeYTPlayer();

          return true;
        }

        return false;
      })
      .catch((error) => {
        console.debug(error);
        return false;
      });
  }

  closeButtonEvents() {
    if (!this.closeEl) {
      return;
    }

    this.closeEl.addEventListener('click', () => {
      this.$container.classList.remove(this.cssClasses.livestreamActive);
      enableBodyScroll();
      this.setCookie();
      this.removeLivestream();
      this.$container.ariaHidden = true;
      window.dispatchEvent(Events.Dismissed);
    });
  }

  displayLivestream() {
    this.$container.classList.add(this.cssClasses.livestreamActive);
    this.$container.ariaHidden = false;
  }

  loadIframe() {
    const src = this.iframeEl.dataset.modalIframeSrc;
    this.iframeEl.src = src;
  }

  initializeYTPlayer() {
    const interval = setInterval(() => {
      if (!window.YT) {
        return;
      }

      window.YT.ready(() => {
        this.loadIframe();
        const player = new window.YT.Player(this.iframeEl, {
          events: {
            onReady: () => {
              console.debug('Youtube API Ready, autoplay video');

              window.dispatchEvent(Events.Activated);
              player.playVideo();
            },
            onStateChange: () => this.stateChangeCallback(),
          },
        });

        window.YoutubeLivestream = player;
        window.YoutubePlayers.push(player);
      });

      clearInterval(interval);
    }, 100);
  }

  loadMockLivestream() {
    const videoData = window.YoutubeLivestream.getVideoData();

    this.videoId = videoData.video_id;
    this.videoChannel = videoData.author;
    this.videoTitle = window.YoutubeLivestream.videoTitle;

    this.videoEvents(window.YoutubeLivestream);
    this.displayLivestream();
    this.initialLoad = false;
  }

  loadLivestream() {
    console.debug('Load livestream...');
    const videoData = window.YoutubeLivestream.getVideoData();

    console.debug(
      `Is Live: ${videoData.isLive}`,
      `Player State: ${window.YoutubeLivestream.getPlayerState()}`,
    );

    // Check if it's live and playing
    if (
      this.initialLoad
      && videoData.isLive
      && window.YoutubeLivestream.getPlayerState() > 0
    ) {
      this.videoId = videoData.video_id;

      // If new livestream video ID is the same as the cookie video ID, do not display livestream and remove the element
      if (getCookie(this.cookieName) === this.videoId) {
        this.removeLivestream();
        return;
      }

      this.videoChannel = videoData.author;
      this.videoTitle = window.YoutubeLivestream.videoTitle;

      this.videoEvents(window.YoutubeLivestream);
      this.displayLivestream();

      this.initialLoad = false;
    }
  }

  mediaQueryEvents() {
    // Adjust styling in landscape
    window
      .matchMedia('(orientation: landscape)')
      .addEventListener('change', (e) => {
        if (e.matches) {
          this.videoWrapperEl.classList.remove(this.cssClasses.videoWrapper);
          this.$container.classList.add(this.cssClasses.livestreamLandscape);
        } else {
          this.$container.classList.remove(this.cssClasses.livestreamLandscape);
          this.videoWrapperEl.classList.add(this.cssClasses.videoWrapper);
        }
      });
  }

  minimizeFullscreenEvents() {
    if (!this.overlayEl || !this.minimizeEl || !this.videoWrapperEl) {
      return;
    }

    this.overlayEl.addEventListener('click', () => {
      // Pause other players if they are playing
      window.YoutubePlayers.forEach((youtubePlayer) => {
        if (
          youtubePlayer.getPlayerState() === 1
          && youtubePlayer !== window.YoutubeLivestream
        ) {
          youtubePlayer.pauseVideo();
        }
      });

      window.YoutubeLivestream.unMute();
      this.videoWrapperEl.classList.add(this.cssClasses.videoWrapper);
      this.$container.classList.add(this.cssClasses.livestreamFullscreen);
      window.dispatchEvent(Events.Maximized);
      disableBodyScroll();
    });

    this.minimizeEl.addEventListener('click', () => {
      window.YoutubeLivestream.mute();
      this.videoWrapperEl.classList.remove(this.cssClasses.videoWrapper);
      this.$container.classList.remove(this.cssClasses.livestreamFullscreen);
      window.dispatchEvent(Events.Minimized);
      enableBodyScroll();
    });
  }

  populateLinks() {
    if (!this.buttonEl) {
      return;
    }

    // If there is an error retrieving stock IDs or if the video title is empty, remove the button element
    if (!this.stockIds || this.stockIds.length === 0) {
      this.buttonEl.remove();
      this.ctaEl.remove();
      return;
    }

    // If there is only one stock ID, populate the existing button
    if (this.stockIds.length === 1) {
      const textEl = this.buttonEl.querySelector('.btn__text');
      this.buttonEl.href = `/inventory/details/${this.stockIds[0]}/`;
      textEl.innerText = this.videoTitle;

      return;
    }

    // If there are multiple stock IDs, populate the existing button for the first stock ID
    // For the other stock IDs, create new buttons and append it to the DOM
    const buttonTemplate = this.buttonEl.cloneNode(true);
    this.stockIds.forEach((stockId, index) => {
      if (index === 0) {
        populateButtonLinkAndText(this.buttonEl, stockId);
      } else {
        const newButton = buttonTemplate;
        populateButtonLinkAndText(newButton, stockId);

        // Append line breaks and new links
        this.detailsEl.append(document.createElement('br'));
        this.detailsEl.append(newButton);
      }
    });
  }

  populateChannel() {
    if (!this.channelEl) {
      return;
    }

    // If video channel is empty, remove the channel element
    if (this.videoChannel === '') {
      this.channelEl.remove();
      return;
    }

    this.channelEl.innerText = this.videoChannel;
  }

  populateTitle() {
    if (!this.titleEl) {
      return;
    }

    // If video title is empty, remove the title element
    if (this.videoTitle === '') {
      this.titleEl.remove();
      return;
    }

    this.titleEl.innerText = this.videoTitle;
  }

  removeLivestream() {
    // Remove livestream element after 200 ms
    // 200 ms is the transition duration
    setTimeout(() => this.$container.remove(), 200);
  }

  setCookie() {
    const expirationDate = new Date();

    // Cookie is set to expire in a day
    expirationDate.setDate(expirationDate.getDate() + 1);
    document.cookie = `${this.cookieName}=${this.videoId}; expires=${expirationDate}; path=/`;
  }

  stateChangeCallback() {
    const state = window.YoutubeLivestream.getPlayerState();
    const videoData = window.YoutubeLivestream.getVideoData();

    if (state === 1 && this.isMockLivestream) {
      console.debug(`Livestream playing, is live: ${videoData.isLive}`);
      this.loadMockLivestream();
      return;
    }

    switch (state) {
    case -1:
      console.debug('Livestream not started');
      break;
    case 0:
      console.debug('Livestream ended');
      this.removeLivestream();
      break;
    case 1:
      console.debug(`Livestream playing, is live: ${videoData.isLive}`);
      window.YoutubeLivestream.playVideo();
      this.loadLivestream();
      break;
    case 2:
      console.debug('Livestream paused');
      break;
    case 3:
      console.debug('Livestream buffering');
      break;
    case 5:
      console.debug('Livestream cued');
      break;
    default:
      console.debug('Cannot retrieve livestream play state');
      break;
    }
  }

  videoEvents() {
    this.mediaQueryEvents();
    this.closeButtonEvents();
    this.minimizeFullscreenEvents();
    this.populateChannel();
    this.populateTitle();
    this.populateLinks();
  }
}
